import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { combineLatest, Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DisplayLinkStats } from '../email-stats/email-stats';
import { LinkActivityHeaderComponent } from './link-activity-header/link-activity-header.component';
import { LinkActivityService } from './link-activity.service';
import { ContactTableComponent } from '../contact-table/contact-table.component';

@Component({
  imports: [CommonModule, GalaxyPageModule, TranslateModule, LinkActivityHeaderComponent, ContactTableComponent],
  templateUrl: 'link-activity.component.html',
  providers: [LinkActivityService],
})
export class LinkActivityComponent implements OnInit {
  backUrl$: Observable<string>;
  url$: Observable<string>;
  selectedLink$: Observable<DisplayLinkStats>;
  allLinkActivity$: Observable<DisplayLinkStats[]>;
  attributeKey$: Observable<string>;
  attributeValue$: Observable<string>;

  constructor(
    private route: ActivatedRoute,
    private linkActivityService: LinkActivityService,
  ) {}

  ngOnInit(): void {
    this.attributeKey$ = this.route.params.pipe(
      map((params) => {
        return params.attributeKey;
      }),
    );
    this.attributeValue$ = this.route.params.pipe(
      map((params) => {
        return params.attributeValue;
      }),
    );
    this.url$ = this.route.queryParams.pipe(
      map((params) => {
        return params.url;
      }),
    );
    this.backUrl$ = this.route.queryParams.pipe(
      map((params) => {
        return params.backUrl;
      }),
    );
    this.allLinkActivity$ = combineLatest([this.attributeKey$, this.attributeValue$]).pipe(
      switchMap(([key, value]) => this.linkActivityService.loadLinkActivity({ key: key, value: value })),
    );

    this.selectedLink$ = this.allLinkActivity$.pipe(
      withLatestFrom(this.url$),
      map(([allLinkActivity, url]) => {
        return allLinkActivity.find((l) => l.url === url);
      }),
    );
  }

  changeLink(linkStats: DisplayLinkStats): void {
    this.selectedLink$ = this.allLinkActivity$.pipe(
      map((links) => {
        return links.find((nextLink) => nextLink.url === linkStats.url);
      }),
    );
    this.url$ = of(linkStats.url);
  }
}
